import firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBtBb4g3tBNGWZYBuNR52N5mwWVQPt1MMs',
  authDomain: 'temperaturas-bde6f.firebaseapp.com',
  projectId: 'temperaturas-bde6f',
  storageBucket: 'temperaturas-bde6f.appspot.com',
  messagingSenderId: '10748045549',
  appId: '1:10748045549:web:dbe9ee9f8dc883f51c44e4',
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const googleProvider = new firebase.auth.GoogleAuthProvider();

googleProvider.setCustomParameters({
  hd: 'tortaplaza.com',
});

export const db = firebase.firestore();
